var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _vm.loading
        ? _c("v-progress-circular", {
            staticClass: "loader",
            attrs: {
              color: "secondary",
              indeterminate: "",
              absolute: "",
              width: "3",
            },
          })
        : _vm._e(),
      _c("div", { staticClass: "swagger", attrs: { id: "swagger" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }